import { types } from "../action-types";

const getInitials = (fullName = "") => {
  const parts = fullName.trim().split(" ").filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`;
  if (parts.length === 1) return parts[0][0];
  return "?";
};

const calcExperienceStr = (experiences) => {
  if (!Array.isArray(experiences) || !experiences.length) return "";
  let totalMonths = 0;
  const now = new Date();
  experiences.forEach((exp) => {
    const startYear = parseInt(exp.start_date_year, 10) || 0;
    if (!startYear) return;
    const startMonth = parseInt(exp.start_date_month, 10) || 1;
    const endYear = exp.is_current
      ? now.getFullYear()
      : parseInt(exp.end_date_year, 10) || startYear;
    const endMonth = exp.is_current
      ? now.getMonth() + 1
      : parseInt(exp.end_date_month, 10) || 12;
    const months = (endYear - startYear) * 12 + (endMonth - startMonth);
    if (months > 0) totalMonths += months;
  });
  const years = Math.round(totalMonths / 12);
  return years ? `${years} yr${years !== 1 ? "s" : ""}` : "";
};

const normalizeDetail = (item) => ({
  _id: item?.profile_id || item?._id || "",
  id: item?.profile_id || item?._id || "",
  name: item?.full_name || "",
  title: item?.title || item?.headline || "",
  avatar: item?.profile_picture_url || null,
  initials: getInitials(item?.full_name),
  aiScore: item?.ai_score || null,
  experience: item?.totalExperience
    ? `${item.totalExperience} yr${item.totalExperience !== 1 ? "s" : ""}`
    : Array.isArray(item?.experience)
      ? calcExperienceStr(item.experience)
      : item?.experience || "",
  location: item?.location || item?.country || "",
  estimatedAmount: "",
  inviteStatus: item?.inviteStatus || null,
  contactInfo: item?.contact_info || null,
  linkedinUrl: item?.linkedin_url || null,
});

const initialState = {
  loading: false,
  error: false,
  data: null,
  rawData: null,
  contactData: null,
  contactLoading: false,
  contactError: false,
};

const externalUserDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EXTERNAL_USER_DETAIL_INIT:
      return {
        ...state,
        loading: true,
        error: false,
        data: null,
        rawData: null,
        contactData: null,
        contactError: false,
      };

    case types.GET_EXTERNAL_USER_DETAIL_SUCCESS: {
      const raw = action.payload?.data || action.payload;
      return {
        ...state,
        loading: false,
        error: false,
        data: normalizeDetail(raw),
        rawData: raw,
      };
    }

    case types.GET_EXTERNAL_USER_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: null,
      };

    case types.FETCH_EXTERNAL_CONTACT_INIT:
      return { ...state, contactLoading: true, contactError: false };

    case types.FETCH_EXTERNAL_CONTACT_SUCCESS:
      return {
        ...state,
        contactLoading: false,
        contactError: false,
        contactData: action.payload?.data || action.payload,
      };

    case types.FETCH_EXTERNAL_CONTACT_FAILURE:
      return { ...state, contactLoading: false, contactError: true, contactErrorMessage: action.payload?.response?.data?.errorMessage || null };

    default:
      return state;
  }
};

export default externalUserDetailReducer;
